export class PagingExpander {
    constructor() {
        const buttonElements = document.querySelectorAll('button.paging__dots');

        buttonElements.forEach(buttonElement => {
            const toggleClassName = 'paging__hidden-links-list--visible';
            const linkList = buttonElement.nextElementSibling;

            const clickHandler = (e) => {
                if (!linkList.contains(e.target) && e.target !== buttonElement) {
                    linkList.classList.remove(toggleClassName);
                    document.removeEventListener('click', clickHandler);
                }
            };

            const toggleLinkListVisibility = (e) => {
                linkList.innerHTML = '';
                this.buildLinks(buttonElement, linkList);
                linkList.classList.toggle(toggleClassName);
                document[linkList.classList.contains(toggleClassName) ? 'addEventListener' : 'removeEventListener']('click', clickHandler);
            };

            buttonElement.addEventListener('click', toggleLinkListVisibility);
        });
    }

    buildLinks = (buttonElement, linkList) => {
        const pagingElement = document.querySelector('.paging');
        const basePaginationUrl = pagingElement.dataset.baseurl;

        const extractLinknumber = element => {
            if (element && element.dataset.linknumber) {
                return Number(element.dataset.linknumber);
            }
            return null;
        };

        const getNextLink = () => {
            let nextElement = buttonElement.parentElement.nextElementSibling;
            while (getComputedStyle(nextElement).display === 'none' && !nextElement.classList.contains('paging__item--next')) {
                nextElement = nextElement.nextElementSibling;
            }
            return nextElement;
        }

        const firstNumber = extractLinknumber(buttonElement.parentElement.previousElementSibling);
        const lastNumber = extractLinknumber(getNextLink());

        if (firstNumber === null || lastNumber === null) {
            return;
        }

        const createListItem = pageNumber => {
            const listItem = document.createElement('li');
            const anchor = document.createElement('a');
            anchor.textContent = pageNumber;
            anchor.classList.add('paging__hidden-link');
            anchor.href = basePaginationUrl.replace('index', pageNumber);
            listItem.appendChild(anchor);
            return listItem;
        };

        for (let i = firstNumber + 1; i < lastNumber; i++) {
            linkList.appendChild(createListItem(i));
        }
    }
}
